import { useState, type FormEvent } from 'react';
import { useNavigate, Link } from 'react-router';
import { useAuthStore } from '@/stores/auth';
import styles from './Login.module.css';

const API = import.meta.env.VITE_API_URL || '/api';

export function Login() {
  const [email, setEmail] = useState(import.meta.env.VITE_DEMO_MODE === 'true' ? 'admin@jiayin.jp' : '');
  const [password, setPassword] = useState(import.meta.env.VITE_DEMO_MODE === 'true' ? 'demo' : '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Login failed');
      login(data.accessToken, data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}>ME</div>
          <div className={styles.logoText}>住縁 Mirai EMS</div>
        </div>
        <div className={styles.subtitle}>SaaS Console</div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label}>メールアドレス</label>
            <input className={styles.input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>パスワード</label>
            <input className={styles.input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <div className={styles.error}>{error}</div>}
          <button className={styles.btn} type="submit" disabled={loading}>
            {loading ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>

        <div className={styles.links}>
          <Link to="/forgot-password" className={styles.link}>パスワードを忘れた方はこちら</Link>
          <span className={styles.linkNote}>メールアドレスがわからない場合はサポート窓口までお問い合わせください</span>
        </div>
        {import.meta.env.VITE_DEMO_MODE === 'true' && <div className={styles.hint}>デモ: admin@jiayin.jp / demo</div>}
      </div>
    </div>
  );
}
